import 'Waypoint'
import { baseDesignWidth } from '@/lib/consts'

export default {
  props: {
    hasBot: { type: Boolean, default () { return false } }
  },
  data () {
    return { activated: false, wpTarget: this, vectH: null }
  },
  watch: {
    activated ( val ) {
      if ( val ) this.$emit( 'activated' )
    }
  },
  mounted () {
    setTimeout( () => {
      let wp = new window.Waypoint( {
        element: this.wpTarget.$el,
        handler: dir => {
          this.active = true
          if ( !this.hasBot ) {
            wp.destroy()
          } else {
            dir === 'down' ? this.$emit( 'enable-bot' ) : this.$emit( 'disable-bot' )
          }
        },
        offset: '80%'
      } )

      if ( this.isIE ) {
        this.vectH = ((this.$el.clientWidth / baseDesignWidth) * this.data.height) + 'px'
      }
    }, 250 )
  }
}



// WEBPACK FOOTER //
// ./src/components/report/mixins/GraphMixin.js